// populates image tags
// product tags are included as a global level variable in product-tags.liquid
$(document).ready(function () {
  try {
    handleProductIconCreationFromTags();
  } catch (e) {
    Rollbar.error('images js', e);
  }
});

export function handleProductIconCreationFromTags() {
  if (typeof productTags == 'object') {
    $('.products--box').each(function () {
      var $this = $(this);
      var tags = $this.find('.products--info').data('tags');
      var tagsArr = tags.split(',');
      const existingIcon = this.querySelector('.product-tag-icon');
      if (!existingIcon) {
        populateProductTags(productTags, tagsArr, $this);
      }
    });
  }
}

export function populateProductTags(productTags, tagsArr, el) {
  for (var i in productTags) {
    if (productTags && productTags[i]) {
      if (tagsArr.indexOf(productTags[i].name) != -1) {
        const category = el.find(' .categories');

        // console.log("El", el.querySelector('.product-tag-icon'))
        // console.log(category.querySelector('img'))
        // if (!category.querySelector('img')) {
        category.append(
          '<img class="product-tag-icon" src="' +
            productTags[i].image +
            '" title="' +
            productTags[i].description +
            '" alt="" width="' +
            productTags[i].sizes[0] +
            '" height="' +
            productTags[i].sizes[1] +
            '">'
        );
        // }
      }
    }
  }
}
